import { LitElement } from '~/lib/bn-lit-element';
import { css, html, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import { bannerStyles } from '../../styles/banner-styles';
import { LitSirenEntityMixin } from '../../utility/lit-siren-entity-mixin';
import './import-mapping-target';

class ImportErrors extends LitSirenEntityMixin(LitElement) {
  static get styles() {
    return [sharedStyles, bannerStyles, css`
      .header {
        margin-bottom: 0.2em;
      }
    `];
  }

  render() {
    const { state, errors } = this.entity.properties;
    if (!errors) {
      return html``;
    }

    return html`
      <div>
        <div class="banner banner--critical">
          <div class="header">${state === 'csv-errored' ? 'CSV Errors' : 'Validation Errors'}</div>
          ${errors.slice(0, 20).map((error) => html`<div><code>${error}</code></div>`)}
          ${renderIf(errors.length > 20, () => html`...`)}
        </div>
      </div>
    `;
  }
}

window.customElements.define('import-errors', ImportErrors);
